import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/api';

export default function UserEditPage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    is_active: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await api.get(`/users`);
        const user = data.users.find(u => u.id === parseInt(userId));
        if (user) {
          setFormData({
            name: user.name || '',
            email: user.email,
            role: user.role,
            is_active: !!user.is_active
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Assuming there's a PATCH /api/users/:id endpoint or similar
      // If not, we'd need to implement it in the backend. 
      // For now, let's assume we can update via a general user update endpoint.
      await api.patch(`/users/${userId}`, formData);
      alert('User updated successfully');
      navigate('/admin');
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to update user');
    }
  };

  if (loading) return <div className="page-content">Loading user details...</div>;

  return (
    <div className="page-content">
      <div className="admin-header">
        <div>
          <h2>Edit User</h2>
          <p>Update account information for {formData.email}</p>
        </div>
        <button className="btn-secondary" onClick={() => navigate('/admin')}>Cancel</button>
      </div>

      <div className="admin-content-card" style={{ padding: '2rem' }}>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>FULL NAME</label>
            <input 
              type="text" 
              className="form-control"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
            />
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>EMAIL ADDRESS</label>
            <input 
              type="email" 
              className="form-control"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
            />
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>ROLE</label>
            <select 
              className="form-control"
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
            >
              <option value="USER">User</option>
              <option value="ADMIN">Admin</option>
            </select>
          </div>
          <div className="form-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>STATUS</label>
            <select 
              className="form-control"
              value={formData.is_active ? '1' : '0'}
              onChange={(e) => setFormData({...formData, is_active: e.target.value === '1'})}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          
          <div style={{ gridColumn: '1 / -1', marginTop: '1rem' }}>
            <button type="submit" className="btn-primary" style={{ padding: '0.75rem 2rem' }}>Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}

